import React from "react";
import { motion } from "framer-motion";
import PersonalInfoMobile from "./Home/PersonalInfoMobile";
import WhatIdo from "./Home/WhatIdo";
import Skills from "./Resume/Skills";

const AboutMe = () => {
  const parentVariant = {
    hidden: {
      opacity: 0,
      x: 200,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 1.8,
        ease: [0, 0.71, 0.2, 1.01],
      },
    },
  };

  const WhatIdoSection = {
    hidden: {
      opacity: 0,
      x: 400,
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 1.9,
        ease: [0, 0.71, 0.2, 1.01],
      },
    },
  };

  return (
    <>
      <motion.div
        variants={parentVariant}
        initial="hidden"
        animate="visible"
        className="pt-12 md:pt-12 px-2 sm:px-5 md:px-10 lg:px-14 bg-b-drop"
      >
        {/* personal info for mobile devices start */}
        <PersonalInfoMobile />

        {/* <!-- about page title --> */}
        <h2 className="after-effect after:left-52 ">About Me</h2>

        <div className="lg:grid grid-cols-12 md:gap-10 py-4 md:pt-5  items-center">
          <div className="col-span-12 ">
            <div className="lg:mr-16 mb-7">
              <p className="text-[#44566c] darkk:text-[#a6a6a6] leading-7">
                A passionate Full Stack Software Developer 🚀 having a special
                interest in Frontend technologies and experience of building Web
                applications with JavaScript / Reactjs / Nodejs and some other
                cool libraries and frameworks.
              </p>
              <p className="text-[#44566c] leading-7 mt-2.5 darkk:text-[#a6a6a6]">
                My aim is to bring across your message and identity in the most
                creative way. I created web design for many famous brand
                companies.
              </p>
            </div>
          </div>
        </div>

        {/* What i do section */}
      </motion.div>
      <motion.div
        variants={WhatIdoSection}
        initial="hidden"
        animate="visible"
        className="pt-2 md:pt-12 px-2 mb-5 mt-5 sm:px-5 md:px-10 lg:px-14 bg-b-drop"
      >
        <WhatIdo />
      </motion.div>

      <div className="pt-2 md:pt-12 px-2 mb-5 mt-5 sm:px-5 md:px-10 lg:px-14 bg-b-drop">
        <Skills />
      </div>
    </>
  );
};

export default AboutMe;
